import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import React from "react"
import { StyleSheet, TouchableOpacity, View } from "react-native"
import moment from "moment"
import { UseParisDateTimeZone } from "@Utils/utils"

export const FreeTimeSelector = (props) => {
    const { parentIndex, selectedFreeslot, setSelectedFreeslot, setActiveSlot, disabled, data } = props
    const Item = (props) => {
        const { item, itemIndex } = props
        const contentId = parentIndex + itemIndex
        const isActive = selectedFreeslot === contentId
        const content = item

        return (
            <TouchableOpacity
                disabled={disabled}
                onPress={() => {
                    console.log({ content })
                    setSelectedFreeslot(contentId)
                    setActiveSlot(content)
                }}
                activeOpacity={0.7}
                style={{ margin: 10 }}
            >
                <View
                    style={{
                        ...styles.container,
                        backgroundColor: isActive ? baseColors.green.primary : baseColors.green.light
                    }}
                >
                    <OpenSansText fontSize={14} color={isActive ? "white" : baseColors.green.dark}>
                        {UseParisDateTimeZone(content?.start_date)}
                    </OpenSansText>
                </View>
            </TouchableOpacity>
        )
    }

    if (data?.length === 0) {
        return (
            <View>
                <OpenSansText style={{ textAlign: "center", fontStyle: "italic" }}>
                    Pas de créneau disponible pour cette date.
                </OpenSansText>
            </View>
        )
    }

    return (
        <View style={styles.row}>
            {data?.map((item, index) => (
                <Item itemIndex={index} item={item} key={index} />
            ))}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        height: 40,
        borderRadius: 10,
        width: 80,
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center"
    },
    col: { flexDirection: "column" },
    row: { flex: 1, flexDirection: "row", justifyContent: "center", flexWrap: "wrap" }
})
